import { Box } from "@mui/material";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSystemStateStore } from "../../store/useSystemStateStore";
import { EdgeSystemStatus, EdgeSystemType } from "../../types";
import { getEndpointConfiguration } from "../../utils";
import { Loader } from "../../components/Loader/Loader";
import { LoginForm } from "./LoginForm";
import { SyncError } from "./SyncError";
import { SyncingBlock } from "./SyncingBlock";
import { LOGIN_PAGE_NS } from "./i18n";

export const LoginPage = () => {
  const { t } = useTranslation(LOGIN_PAGE_NS);
  const { isCloud } = getEndpointConfiguration();
  const { systemState, hasCompletedInitialSync } = useSystemStateStore();

  const syncStatus = systemState[EdgeSystemType.DataSync].status;
  const isPerformingInitialSync = !isCloud && !hasCompletedInitialSync;
  
  useEffect(() => {
    document.title = isPerformingInitialSync ? t("documentTitle.sync") : t("documentTitle.login");
  }, [isPerformingInitialSync, t]);

  const otpLoginForm = <LoginForm />

  const onboardLoginForms = {
    [EdgeSystemStatus.Initial]: <Loader simple />,
    [EdgeSystemStatus.Ongoing]: <SyncingBlock /> ,
    [EdgeSystemStatus.Error]: <SyncError />,
    [EdgeSystemStatus.Success]: otpLoginForm,
  };

  const form = isCloud || hasCompletedInitialSync ? otpLoginForm : onboardLoginForms[syncStatus];

  const renderedForm = (
    <Box sx={{ display: "flex", justifyContent: "center", m: "0 auto" }}>
      {form}
    </Box>
  );

  return renderedForm;
};
